import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {setRequestId} from "../utils/setRequestId";

export const checkIdNumber = (idNumber) => {
  return (dispatch) => {
    dispatch({
      type: A.CHECK_ID_NUMBER
    });
    setRequestId();

    const data = {idNumber};

    return axios.post('/regGeneral/checkIdNumber', data)
      .then((response) => {
        const {data} = response.data;
        const {idNumberUsed} = data;
        dispatch({
          type: A.CHECK_ID_NUMBER_SUCCESS,
          payload: {idNumberUsed}
        });

        return idNumberUsed;
      })
      .catch((err) => {
        return dispatch({
          type: A.CHECK_ID_NUMBER_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  };
};
